
fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
        const cartAttributes = cartData.attributes;
        const cartItems = cartData.items;
        const uidsInCart = cartItems.map(item => {
            if (item.properties && item.properties['Related to Glasses UID']) {
                return item.properties['Related to Glasses UID'];
            }
            return null;
        }).filter(uid => uid !== null);
        const filteredAttributes = {};
        for (const key in cartAttributes) {
            if (cartAttributes.hasOwnProperty(key)) {
                const uid = key.split(' ')[2];
                if (uidsInCart.includes(`cristal-${uid}`)) {
                    filteredAttributes[key] = cartAttributes[key];
                } else {
                    filteredAttributes[key] = '';
                }
            }
        }
        const updateData = {
            attributes: filteredAttributes
        };
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(updateData)
        })
            .then(response => response.json())
            .then(updatedCart => {
                console.log('Cart updated Successfully:');
            })
            .catch(error => {
                console.error('Error updating cart:', error);
            });

    })
    .catch(error => {
        console.error('Error fetching cart data:', error);
    });
